import CodeMirror, {placeholder} from '@uiw/react-codemirror';
import {python} from '@codemirror/lang-python';
import {cpp} from '@codemirror/lang-cpp';
import {java} from '@codemirror/lang-java';
import {rust} from '@codemirror/lang-rust';
import {javascript} from '@codemirror/lang-javascript';
import {CopyIcon} from '@chakra-ui/icons';
import React from "react";
import {Box, Flex, Button, Select, Spinner, Text, useToast} from "@chakra-ui/react";

export default function OptimizeLayout() {
    const [code, setCode] = React.useState('');
    const [language, setLanguage] = React.useState('python');
    const [optimizedCode, setOptimizedCode] = React.useState('');
    const [explanation, setExplanation] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [languageExtension, setLanguageExtension] = React.useState(python());
    const toast = useToast()

    function onSubmit(event) {
        setLoading(true);
        if (code === '') {
            toast({
                title: 'Empty code',
                description: "Please input some code to optimize in the left box.",
                status: 'error',
                duration: 2000,
                isClosable: true,
            })
            setLoading(false);
            return;
        }
        console.log("submitting code!", loading)
        fetch(`https://code-optimize-demo-axdlm3efaa-uc.a.run.app/optimize`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'//`${process.env.REACT_APP_API_URL}`
            },
            body: JSON.stringify({code: code, language: language})
        })
            .then(res => res.json())
            .then((data) => {
                console.log("data", data);
                setOptimizedCode(data.code);
                setExplanation(data.explanation);
            }).catch((e) => {
            toast({
                description: `Error optimizing code, please try again or with some other code`, status: 'error',
                duration: 4000,
                isClosable: true,
            })
        })
            .finally(() => setLoading(false));
    }

    function onLanguageChangeHandle(e) {
        setLanguage(e.target.value);
        switch (e.target.value) {
            case 'python':
                setLanguageExtension(python());
                break;
            case 'javascript':
                setLanguageExtension(javascript());
                break;
            case 'java':
                setLanguageExtension(java());
                break;
            case 'c++':
                setLanguageExtension(cpp());
                break;
            case 'rust':
                setLanguageExtension(rust());
                break;
            default:
                setLanguageExtension(python());
                break;
        }
    }

    React.useEffect(() => {

    }, [loading])

    return (
        <>
            <Flex flexDirection="row">
                <Flex flexDirection="column">
                    <Flex flexDirection="row" alignItems='center'>
                        <Text>Language: </Text>
                        <Select w="250px" variant='outline' onChange={onLanguageChangeHandle}>
                            <option value='python'>Python</option>
                            <option value='javascript'>Javascript</option>
                            <option value='java'>Java</option>
                            <option value='c++'>C++</option>
                            <option value='rust'>Rust</option>
                        </Select>
                    </Flex>

                    <CodeMirror value={code} width="800px" height="90vh" extensions={[languageExtension]}
                                placeholder={'Enter your code here'}
                                onChange={(evn) => {
                                    setCode(evn)
                                }}/>
                    <Flex flexDirection={'row'} alignItems='center'>
                        <Button colorScheme='blue' w='200px' loadingText='Optimizing...' isLoading={loading}

                                onClick={() => {
                                    setLoading(true);
                                    onSubmit()
                                }}>Optimize</Button>
                        {loading ?
                            <Text ml="10px">Please be patient, it takes about a minute to optimize...</Text> : null}
                    </Flex>

                </Flex>
                <Flex flexDirection="column">
                    {explanation === '' ? <Box h="40px"/> :
                        <Box>
                            {explanation}
                        </Box>}
                    <Box w="500px">

                        <CodeMirror value={optimizedCode} width="800px" height="70vh" extensions={[languageExtension]}
                                    editable={false} placeholder={'Optimized code comes out here...'}/>
                    </Box>
                    {optimizedCode !== '' ?
                        <Button colorScheme='blue' w='200px' rightIcon={<CopyIcon/>} onClick={() => {
                            navigator.clipboard.writeText(optimizedCode);
                            toast({
                                description: "Copied to clipboard",
                                status: 'success',
                                duration: 2000,
                                isClosable: true
                            })
                        }}>Copy Code</Button> : null}
                </Flex>
            </Flex>
        </>
    )
}